// ─────────────────────────────────────────────────────────────
// Admin Account Management service — frontend
// Phase 10
// ─────────────────────────────────────────────────────────────

import { apiGet, apiPost, apiPut, apiDelete } from './api';
import type { AdminUserView, CreateUserInput, UpdateStatusInput, UpdatePasswordInput } from '../types/admin-user.types';

export const adminUserService = {
  /** List all accounts (admin only) */
  listUsers(): Promise<AdminUserView[]> {
    return apiGet<AdminUserView[]>('/admin/users');
  },

  /** Create a new account */
  createUser(input: CreateUserInput): Promise<AdminUserView> {
    return apiPost<AdminUserView>('/admin/users', input);
  },

  /** Lock or unlock an account */
  updateStatus(userId: string, input: UpdateStatusInput): Promise<AdminUserView> {
    return apiPut<AdminUserView>(`/admin/users/${userId}/status`, input);
  },

  /** Set new password for an account (admin only) */
  updatePassword(userId: string, input: UpdatePasswordInput): Promise<AdminUserView> {
    return apiPut<AdminUserView>(`/admin/users/${userId}/password`, input);
  },

  /** Delete an account and all owned data */
  deleteUser(userId: string): Promise<{ id: string }> {
    return apiDelete<{ id: string }>(`/admin/users/${userId}`);
  },
};
